export interface User {
  accessExpiryTime: string;
  activeDirectoryCreationTime: string;
  disabled: boolean;
  emailAddress: string;
  guid: string;
  id: number;
  roles: Role[];
  username: string;
  name: string;
}

export interface Role {
  guid: string;
  id: number;
  name: string;
  tag: string;
}

export interface RoutePermissions {
  [route: string]: (permissions: any) => boolean;
}

export class AuthenticationRequest {
  username: string;
  password: string;
  remember: boolean;
  isImplementerEnvironment: boolean;
}

export interface AuthenticationResponse<TUser> {
  access_token: string;
  token_type: string;
  expires_in: number;
  user: TUser;
  error: string;
}

export class Email {
  emailAddress: string;
}

export class PasswordReset {
  NewPassword: string;
  NewPasswordConfirm: string;
  Guid: string;
}

export class PasswordChange {
  CurrentPassword: string;
  NewPassword: string;
  NewPasswordConfirm: string;
}



// WEBPACK FOOTER //
// ./src/_foundation/models/security.models.ts